"use strict";
window.CI = window.CI || {};

(function ($, $$) {
  
  $$.setting = {
    _breakpoint: -1,
    breakpoint: -1,
    windowWidth: -1,
    windowHeight: -1,
    scrollTop: -1,
    scrollBtm: -1,
    tmpScrollTop: -1,
    mql: -1,
    bp1: 480,
    bp2: 768,
  };
  $$.setting.mql = window.matchMedia(`(min-width: ${$$.setting.bp1 + 1}px) and (max-width: ${$$.setting.bp2}px)`);
  $$.elem = {
    body: document.querySelector('body'),
    header: document.getElementById('shopify-section-header'),
    container: document.getElementById('MainContent'),
    footer: document.getElementById('shopify-section-footer')
  };
  $$.flag = {
    isPC: (window.matchMedia('(min-width: 993px)').matches),
    isTB: (!window.matchMedia('(max-width: 576px)').matches && !window.matchMedia('(min-width: 993px)').matches),
    isSP: (window.matchMedia('(max-width: 576px)').matches),
  };
  $$.ease = {
    in: {},
    out: {
      cubic: (x) => {
        return 1 - Math.pow(1 - x, 3);
      },
    },
    inout: {}
  };
  $$.fn = $$.fn || {};
    
  /**
   * メディアクエリに応じたイベントをトリガーする
   */
  $$.fn.mqChecker = () => {
    $$.flag.isPC = $$.flag.isTB = $$.flag.isSP = false;
    if (window.matchMedia('(min-width: 993px)').matches) {
      $$.flag.isPC = true;
      window.dispatchEvent(new Event('isPC'));
    } else if (window.matchMedia('(max-width: 576px)').matches) {
      $$.flag.isSP = true;
      window.dispatchEvent(new Event('isSP'));
    } else {
      $$.flag.isTB = true;
      window.dispatchEvent(new Event('isTB'));
    }
  };
  /**
   * 指定した要素のoffsetを取得する
   * @param {object} _elem offsetを取得したい要素のオブジェクト
   * @param {string} _type offsetを取得する位置（top, left, right, bottom）
   * @returns 指定したoffsetの数値
   */
  $$.fn.getOffset = (_elem, _type) => {
    let result = 0;
    let rect = _elem.getBoundingClientRect();

    if (_type === 'top') {
      result = rect.top + window.pageYOffset;
    } else if (_type === 'left') {
      result = rect.left + window.pageXOffset;
    } else if (_type === 'right') {
      result = rect.left + window.pageXOffset + _elem.clientWidth;
    } else if (_type === 'bottom') {
      result = rect.top + window.pageYOffset + _elem.clientHeight;
    }
    return result;
  };
  /**
   * 指定した位置へスムーススクロールする
   * @param {number} target スムーススクロールしたい位置の数値（px）
   * @param {number} time スムーススクロールにかけたい時間（ms）
   * @param {*} easing スムーススクロール時のイージング（基本的に省略）
   */
  $$.fn.smoothScroll = (target, time = 1000, easing = $$.ease.out.cubic) => {
    let startPos = document.documentElement.scrollTop || document.body.scrollTop;
    let startTime = Date.now();
    let distance = target - startPos;
    let position = 0;

    const runScroll = () => {
      let nowTime = Date.now();
      let elapsed = (time - (nowTime - startTime) > 0) ? (nowTime - startTime) : time;
      let progress = elapsed / time;
      position = startPos + (distance * easing(progress));
      window.scrollTo(0, position);
      if (elapsed < time) requestAnimationFrame(runScroll);
    };
    requestAnimationFrame(runScroll);
  };

  

  /**
   * ページ内アンカークリック時のスムーススクロール
   */
  const anchorLink = () => {
    let anchorArr = document.querySelectorAll('a');

    [...anchorArr].map((el) => {
      el.addEventListener('click', (e) => {
        let targetID = el.getAttribute('href').match(/^\#(.*?)$/)[1];
        let headerHeight = document.querySelector('#SiteHeader').clientHeight;
          if(window.innerWidth < 769) {  
            headerHeight = document.querySelector('#SiteHeaderSP').clientHeight;
          }
        // let headerHeight = 109;
        
        if(!targetID) return;
        e.preventDefault();

        let $target = document.getElementById(targetID);
        let targetOffsetTop = $$.fn.getOffset($target, 'top');

        $$.fn.smoothScroll(targetOffsetTop - headerHeight);
      });
    });
  };
  
  
  
  /**
   * グローバル変数に値を代入
   */
  const setGlobalSettings = () => {
    $$.setting.windowWidth = document.documentElement.clientWidth;
    $$.setting.windowHeight = document.documentElement.clientHeight;
    $$.setting.scrollTop = window.pageYOffset;
    $$.setting.scrollBtm = window.pageYOffset + $$.setting.windowHeight;
  };
  
    /**
   * DOM Ready時に実行したい処理
   * @param {*} e
   */
  const windowDOMLoadedHandler = () => {
    $$.fn.mqChecker();
    anchorLink();
  };
  /**
   * window Load時に実行したい処理
   */
  const windowLoadHandler = () => {
  };
  /**
   * window Scroll時に実行したい処理
   */
  const windowScrollHandler = () => {
  };
  /**
   * window Resize時に実行したい処理
   */
  const windowResizeHandler = () => {

  };
  
  ['DOMContentLoaded', 'load', 'resize', 'scroll'].map((event) => {
    window.addEventListener(event, (e) => {
      setGlobalSettings();

      if (event === 'DOMContentLoaded') {
        windowDOMLoadedHandler(e);
      } else if (event === 'load') {
        windowLoadHandler(e);
      } else if (event === 'scroll') {
        windowScrollHandler();
      } else if (event === 'resize') {
        windowResizeHandler();
      }

    });
  });
  

  window.addEventListener('bodyFixedOn', () => {
    $$.setting.tmpScrollTop = $$.setting.scrollTop;
    $$.elem.body.style.position = 'fixed';
    $$.elem.body.style.top = `-${$$.setting.scrollTop}px`;
  });

  window.addEventListener('bodyFixedOff', () => {
    $$.elem.body.style.position = '';
    $$.elem.body.style.top = ``;
    window.scrollTo(0, $$.setting.tmpScrollTop);
  });

  $$.setting.mql.addEventListener("change", () => {
    $$.fn.mqChecker();
    window.dispatchEvent(new Event('breakpointSwitched'));
  });
  
  
})(document, window.CI);